import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {acceptPrivacyPolicy, fetchPrivacyPolicyIfNeeded} from 'ondemand/actions/privacyPolicy';
import {getPrivacyPolicyAccepted} from 'ondemand/selectors';
import PrivacyPolicyModal from 'ondemand/components/PrivacyPolicyModal';

class PrivacyPolicyGuard extends React.Component {
  static displayName = 'PrivacyPolicyGuard';

  static propTypes = {
    accepted: PropTypes.bool,
    children: PropTypes.node,
    dispatch: PropTypes.func.isRequired,
  };

  state = {checked: false};

  componentDidMount() {
    this.props.dispatch(fetchPrivacyPolicyIfNeeded());
  }

  _handleCheckboxToggle = () => {
    this.setState(({checked}) => ({checked: !checked}));
  };

  _handleAccept = () => {
    this.props.dispatch(acceptPrivacyPolicy());
  };

  render() {
    const {accepted, children} = this.props;

    if (accepted === null) return null; // privacy policy status is loading

    if (accepted) {
      return children;
    }

    return (
      <PrivacyPolicyModal
        checked={this.state.checked}
        onCheckboxToggle={this._handleCheckboxToggle}
        onAccept={this._handleAccept}
      />
    );
  }
}

const mapStateToProps = state => ({
  accepted: getPrivacyPolicyAccepted(state),
});

export default connect(mapStateToProps)(PrivacyPolicyGuard);



// WEBPACK FOOTER //
// ./src/ondemand/containers/PrivacyPolicyGuard.js